import { kebabCase } from 'es-toolkit/compat';
import { z } from 'zod';
import { LOAD_ORDER_BY_FIELDS } from './LoadsPageParams';

const LOAD_GROUP_BY_TABS = [
  'new',
  'assigned',
  'in-terminal',
  'picked-up',
  'delivered',
  'billed',
  'paid',
  'archived',
] as const;

export type LoadGroupByTab = (typeof LOAD_GROUP_BY_TABS)[number];

function isLoadGroupByTab(value: unknown): value is LoadGroupByTab {
  return (
    typeof value == 'string' &&
    LOAD_GROUP_BY_TABS.includes(value as LoadGroupByTab)
  );
}

export function toLoadGroupByTab(input: unknown): LoadGroupByTab | undefined {
  const value = typeof input == 'string' ? kebabCase(input) : undefined;

  return isLoadGroupByTab(value) ? value : undefined;
}

export type LoadGroupByParams = z.infer<typeof loadGroupByParamsSchema>;
const zodStringParam = z.preprocess((value) => {
  if (value == null) {
    return null;
  }

  const next = String(value).trim();

  return next.length > 0 ? next : null;
}, z.string().nullable().default(null).catch(null));

export const loadGroupByParamsSchema = z.object({
  tab: z
    .enum(LOAD_GROUP_BY_TABS)
    .catch(LOAD_GROUP_BY_TABS[0])
    .default(LOAD_GROUP_BY_TABS[0]),
  groupby: z
    .enum(LOAD_ORDER_BY_FIELDS)
    .catch(LOAD_ORDER_BY_FIELDS[0])
    .default(LOAD_ORDER_BY_FIELDS[0]),

  drivers: zodStringParam,
  terminals: zodStringParam,
  dispatchers: zodStringParam,
});

export interface LoadGroupByOptionDTO {
  count: number;
  name: boolean | string | null;
}

export interface LoadGroupByOptionsDTO {
  items: LoadGroupByOptionDTO[] | null;
}
